module.exports = __webpack_public_path__ + "static/media/monitor-heart-rate.13a693e3.svg";